import { useEffect } from "react";
import Footer from "../../Components/Footer/Footer";
import HomeNavbar from "../../Components/HomeNavbar/HomeNavbar";
import "./legal.css";
import SEOHead from "../../Components/SEOHead/SEOHead";
import { getSEOByPath } from "../../config/seoConfig";

const TermsOfUse = () => {
  const seoData = getSEOByPath("/terms-of-use");
  
  useEffect(() => {
    window.scrollTo(0, 0); // This will scroll the page to the top
  }, []);

  return (
    <div className="legal_container">
      {seoData && (
        <SEOHead 
          title={seoData.title}
          description={seoData.description}
          canonical={seoData.canonical}
        />
      )}
      <HomeNavbar isHome={true} />
      {/* <div className="main_home_wrapper"> */}
      <div className="legal_content">
        <h1 className="legal_heading">Terms Of Use</h1>
        <div className="legal_wrapper">
          This page (together with the documents referred to on it) tells you
          the terms of use on which you may make use of our website
          http://tascoutsourcing.com (our site), whether as a guest or a
          registered user. Please read these terms of use carefully before you
          start to use the site. By using our site, you indicate that you accept
          these terms of use and that you agree to abide by them. If you do not
          agree to these terms of use, please refrain from using our site.
        </div>
        <div className="legal_wrapper">
          <h2 className="legal_sub_heading">Information about us</h2>
          <p>
            http://tascoutsourcing.com is a site operated by TASC Outsourcing
            (“We”).
          </p>
        </div>
        <div className="legal_wrapper">
          <h2 className="legal_sub_heading">Accessing our site</h2>
          <p>
            Access to our site is permitted on a temporary basis, and we reserve
            the right to withdraw or amend the service we provide on our site
            without notice (see below). We will not be liable if for any reason
            our site is unavailable at any time or for any period.
          </p>
          <p>
            From time to time, we may restrict access to some parts of our site,
            or our entire site, to users who have registered with us.
          </p>

          <p>
            If you choose, or you are provided with, a user identification code,
            password or any other piece of information as part of our security
            procedures, you must treat such information as confidential, and you
            must not disclose it to any third party. We have the right to
            disable any user identification code or password, whether chosen by
            you or allocated by us, at any time, if in our opinion you have
            failed to comply with any of the provisions of these terms of use.
          </p>
          <p>
            You are responsible for making all arrangements necessary for you to
            have access to our site. You are also responsible for ensuring that
            all persons who access our site through your internet connection are
            aware of these terms, and that they comply with them.
          </p>
        </div>
        <div className="legal_wrapper">
          <h2 className="legal_sub_heading">Intellectual property rights</h2>
          <p>
            We are the owner or the licensee of all intellectual property rights
            in our site, and in the material published on it. Those works are
            protected by copyright laws and treaties around the world. All such
            rights are reserved.
          </p>
          <p>
            You may print off one copy, and may download extracts, of any
            page(s) from our site for your personal reference and you may draw
            the attention of others within your organisation to material posted
            on our site.
          </p>

          <p>
            You must not modify the paper or digital copies of any materials you
            have printed off or downloaded in any way, and you must not use any
            illustrations, photographs, video or audio sequences or any graphics
            separately from any accompanying text.
          </p>
          <p>
            Our status (and that of any identified contributors) as the authors
            of material on our site must always be acknowledged.
          </p>
          <p>
            You must not use any part of the materials on our site for
            commercial purposes without obtaining a licence to do so from us or
            our licensors.
          </p>
          <p>
            If you print off, copy or download any part of our site in breach of
            these terms of use, your right to use our site will cease
            immediately and you must, at our option, return or destroy any
            copies of the materials you have made.
          </p>
        </div>
        <div className="legal_wrapper">
          <h2 className="legal_sub_heading">Reliance on information posted</h2>
          <p>
            Commentary and other materials posted on our site are not intended
            to amount to advice on which reliance should be placed. We therefore
            disclaim all liability and responsibility arising from any reliance
            placed on such materials by any visitor to our site, or by anyone
            who may be informed of any of its contents.
          </p>
        </div>
        <div className="legal_wrapper">
          <h2 className="legal_sub_heading">Our site changes regularly</h2>
          <p>
            We aim to update our site regularly, and may change the content at
            any time. If the need arises, we may suspend access to our site, or
            close it indefinitely. Any of the material on our site may be out of
            date at any given time, and we are under no obligation to update
            such material.
          </p>
        </div>
        <div className="legal_wrapper">
          <h2 className="legal_sub_heading">Our liability</h2>
          <p>
            The material displayed on our site is provided without any
            guarantees, conditions or warranties as to its accuracy. To the
            extent permitted by law, we, other members of our group of companies
            and third parties connected to us hereby expressly exclude:
          </p>
          <p>
            All conditions, warranties and other terms which might otherwise be
            implied by statute, common law or the law of equity.
          </p>
          <p>
            Any liability for any direct, indirect or consequential loss or
            damage incurred by any user in connection with our site or in
            connection with the use, inability to use, or results of the use of
            our site, any websites linked to it and any materials posted on it,
            including, without limitation any liability for:
          </p>
          <ul>
            <li>loss of income or revenue;</li>
            <li>loss of business;</li>
            <li>loss of profits or contracts;</li>
            <li>loss of anticipated savings;</li>
            <li>loss of data;</li>
            <li>loss of goodwill;</li>
            <li>wasted management or office time; and</li>
          </ul>
          <p>
            for any other loss or damage of any kind, however arising and
            whether caused by tort (including negligence), breach of contract or
            otherwise, even if foreseeable, provided that this condition shall
            not prevent claims for loss of or damage to your tangible property
            or any other claims for direct financial loss that are not excluded
            by any of the categories set out above.
          </p>
          <p>
            This does not affect our liability for death or personal injury
            arising from our negligence, nor our liability for fraudulent
            misrepresentation or misrepresentation as to a fundamental matter,
            nor any other liability which cannot be excluded or limited under
            applicable law.
          </p>
        </div>
        <div className="legal_wrapper">
          <h2 className="legal_sub_heading">
            Information about you and your visits to our site
          </h2>
          <p>
            We process information about you in accordance with our privacy
            policy. By using our site, you consent to such processing and you
            warrant that all data provided by you is accurate.
          </p>
        </div>
        <div className="legal_wrapper">
          <h2 className="legal_sub_heading">Uploading material to our site</h2>
          <p>
            Whenever you make use of a feature that allows you to upload
            material to our site, or to make contact with other users of our
            site, you must comply with the content standards set out in this
            document as well as our Privacy policy. You warrant that any such
            contribution does comply with those standards, and you indemnify us
            for any breach of that warranty.
          </p>
          <p>
            Any material you upload to our site will be considered
            non-confidential and non-proprietary, and we have the right to use,
            copy, distribute and disclose to third parties any such material for
            any purpose. We also have the right to disclose your identity to any
            third party who is claiming that any material posted or uploaded by
            you to our site constitutes a violation of their intellectual
            property rights, or of their right to privacy.
          </p>
          <p>
            We will not be responsible, or liable to any third party, for the
            content or accuracy of any materials posted by you or any other user
            of our site.
          </p>
          <p>
            We have the right to remove any material or posting you make on our
            site if, in our opinion, such material does not comply with the
            content standards set out in any of our policies.
          </p>
        </div>
        <div className="legal_wrapper">
          <h2 className="legal_sub_heading">
            Viruses, hacking and other offences
          </h2>
          <p>
            You must not misuse our site by knowingly introducing viruses,
            trojans, worms, logic bombs or other material which is malicious or
            technologically harmful. You must not attempt to gain unauthorised
            access to our site, the server on which our site is stored or any
            server, computer or database connected to our site. You must not
            attack our site via a denial-of-service attack or a distributed
            denial-of service attack.
          </p>
          <p>
            By breaching this provision, you would commit a criminal offence. We
            will report any such breach to the relevant law enforcement
            authorities and we will co-operate with those authorities by
            disclosing your identity to them. In the event of such a breach,
            your right to use our site will cease immediately.
          </p>
          <p>
            We will not be liable for any loss or damage caused by a distributed
            denial-of-service attack, viruses or other technologically harmful
            material that may infect your computer equipment, computer programs,
            data or other proprietary material due to your use of our site or to
            your downloading of any material posted on it, or on any website
            linked to it.
          </p>
        </div>
        <div className="legal_wrapper">
          <h2 className="legal_sub_heading">Linking to our site</h2>
          <p>
            You may link to our home page, provided you do so in a way that is
            fair and legal and does not damage our reputation or take advantage
            of it, but you must not establish a link in such a way as to suggest
            any form of association, approval or endorsement on our part where
            none exists.
          </p>
        </div>
        <div className="legal_wrapper">
          <h2 className="legal_sub_heading">
            You must not establish a link from any website that is not owned by
            you
          </h2>
          <p>
            Our site must not be framed on any other site, nor may you create a
            link to any part of our site other than the home page. We reserve
            the right to withdraw linking permission without notice. The website
            from which you are linking must comply in all respects with the
            content standards set out in our policies.
          </p>
          <p>
            If you wish to make any use of material on our site other than that
            set out above, please address your request to
            info@tascoutsourcing.com .
          </p>
        </div>
        <div className="legal_wrapper">
          <h2 className="legal_sub_heading">Links from our site</h2>
          <p>
            Where our site contains links to other sites and resources provided
            by third parties, these links are provided for your information
            only. We have no control over the contents of those sites or
            resources, and accept no responsibility for them or for any loss or
            damage that may arise from your use of them.
          </p>
        </div>
        <div className="legal_wrapper">
          <h2 className="legal_sub_heading">Jurisdiction and applicable law</h2>
          <p>
            The UAE courts will have exclusive jurisdiction over any claim
            arising from, or related to, a visit to our site although we retain
            the right to bring proceedings against you for breach of these
            conditions in your country of residence or any other relevant
            country.
          </p>
          <p>
            These terms of use and any dispute or claim arising out of or in
            connection with them or their subject matter or formation (including
            non-contractual disputes or claims) shall be governed by and
            construed in accordance with the law of UAE.
          </p>
        </div>
        <div className="legal_wrapper">
          <h2 className="legal_sub_heading">Variations</h2>
          <p>
            We may revise these terms of use at any time by amending this page.
            You are expected to check this page from time to time to take notice
            of any changes we made, as they are binding on you. Some of the
            provisions contained in these terms of use may also be superseded by
            provisions or notices published elsewhere on our site.
          </p>
        </div>
        <div className="legal_wrapper">
          <h2 className="legal_sub_heading">Your concerns</h2>
          <p>
            If you have any concerns about material which appears on our site,
            please contact info@tascoutsourcing.com .
          </p>
          <p>Thank you for visiting our site.</p>
        </div>
      </div>
      {/* <div className="footer_section">
        <div>
          © Copyright 2024{" "}
          <a
            href="https://tascoutsourcing.com/en"
            target="_blank"
            className="white_link"
          >
            TASC Outsourcing
          </a>
          . All rights reserved
        </div>
        <div className="privacy_container">
          <a
            href="https://falektayyeb.ae/privacy-policy"
            target="_self"
            className="white_link"
          >
            Privacy Policy
          </a>
          <a
            href="https://falektayyeb.ae/terms-of-use"
            className="white_link"
            target="_self"
          >
            Terms Of Use
          </a>
        </div>
      </div> */}
      <Footer />
    </div>
  );
};

export default TermsOfUse;
